import DPTextBox from "framework/components/DPTextBox"
import React from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import UserPoliciesTab1 from "./userPoliciesTab1"
const UserPolicies = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>User Password</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="My Utilities" breadcrumbItem="User Policies" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={true}
                    helpClick={() => {
                      alert("Help")
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={() => {
                      alert("Favorite")
                    }}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      alert("New")
                    }}
                    //Save Button
                    saveEnable={true}
                    saveClick={() => {
                      alert("Save")
                    }}
                    //ProcessButton
                    processEnable={true}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={true}
                    editClick={() => {
                      alert("Edit")
                    }}
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      alert("Print")
                    }}
                    //Delete Button
                    deleteEnable={true}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={false}
                    exitClick={() => {
                      alert("Exit")
                    }}
                  />
                  <Row>
                      <p></p>
                      <Col sm={12} md={6} className="mb-4-sm">
                  <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="Role ID"
                          textType="number"
                          maxLength="20"
                        />
                        <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="Name:"
                          textType="text"
                          maxLength="20"  
                          placeholder="text"
                        />
                        
                         <div style={{paddingTop:"2rem"}}>
                         <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="Search Records"
                          placeholder="Search"
                          textType="text"
                          maxLength="20"
                        />
                         </div>
                         </Col>
                  </Row>
                  <Row>
                      <Row >
                          <UserPoliciesTab1></UserPoliciesTab1>
                      </Row>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default UserPolicies
